export const MIN_U8 = 0x00;
export const MAX_U8 = 0xff;

export const MIN_I8 = -0x80;
export const MAX_I8 = 0x7f;

export const MIN_I16 = -0x8000;
export const MAX_I16 = 0x7fff;

export const MIN_I32 = -0x80000000;
export const MAX_I32 = 0x7fffffff;

export const MIN_I64 = -BigInt("0x8000000000000000");
export const MAX_I64 = BigInt("0x7fffffffffffffff");

export const MIN_I256 = -BigInt(
  "0x8000000000000000000000000000000000000000000000000000000000000000"
);

export const MAX_I256 = BigInt(
  "0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
);
